import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {MODAL_DATA} from '../../../../injection-token/modal-data';
import {BreakLinesPipe} from "../../../../pipe/BreakLineReplacePipe";
import {AppConfig} from '../../../../model/AppConfig';
import {APP_CONFIG} from '../../../../injection-token/app-config';

export type ErrorDialogData = {
  title: string;
  message: string | null;
  stacktrace?: string | null;
  path?: string | null;
  cause?: string | null;
  status?: number | null;
}

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.sass'],
    imports: [
        BreakLinesPipe
    ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorDialogComponent {
  dialogRef = inject(NgbActiveModal);
  private readonly appConfig = inject<AppConfig>(APP_CONFIG);
  modalData = inject<ErrorDialogData>(MODAL_DATA);


  data: ErrorDialogData;

  constructor() {
    const modalData = this.modalData;

    this.data = modalData;
  }

  isDebugModeOn(): boolean {
    return this.appConfig.environment != "prod";
  }
}
